<script setup lang="ts">
import { computed, type PropType } from 'vue';

import { PhxsgIcon, type PhxsgIconIds } from '@sg/src/View/Components/Atoms/Icon';
import './scroll-incentive.css';

const props = defineProps({
  label: {
    type: String,
    default: 'Scroll',
  },
  interactive: {
    type: Boolean,
    default: true,
  },
  iconId: {
    type: String as PropType<PhxsgIconIds>,
    default: 'chevron-down',
  },
});

defineEmits<(e: 'click', ev: MouseEvent) => void>();

const getAttributes = computed(() =>
  props.interactive
    ? {
        'aria-label': props.label,
        type: 'button',
      }
    : { 'aria-hidden': 'true' },
);
</script>

<template>
  <component
    :is="interactive ? 'button' : 'div'"
    :class="['phxsg-scroll-incentive', { 'phxsg-scroll-incentive--interactive': interactive }]"
    v-bind="getAttributes"
    @click="interactive && $emit('click', $event)"
  >
    <div class="phxsg-scroll-incentive__arrow">
      <PhxsgIcon :id="iconId" :title="label" size="2xl" />
    </div>
  </component>
</template>
